import * as t from "io-ts"

// ******************************************************************
// Publish
// ******************************************************************/

export const PublishEvdcDevicePostBody = t.type({
    device_type: t.literal("EVDC"),
    device_data: t.intersection([
        t.type({
            Model: t.string,
            Make: t.string,
            ModelReference: t.string,
            EVCPType: t.string,
            Module: t.string,
            Phases: t.number,
            Voltage: t.number,
            TotalEVCPInputRatedCurrent: t.number,
            TotalEVCPInputRatedPower: t.number,
            TotalEVCPMaxDemandCurrent: t.number,
            TotalEVCPMaxDemandPower: t.number,
            ModuleInputRatedCurrent: t.number,
            ModuleInputRatedPower: t.number,
            AppTestStandards_HarmonicStandards: t.string,
            Comments_AppTestStandards_Notes: t.string,
            Attachment_UUID: t.string,
        }),
        t.partial({
            ManufacturerID: t.string,
            SystemReference: t.string,
        }),
    ]),
})

export type TPublishEvdcDevicePostBody = t.TypeOf<
    typeof PublishEvdcDevicePostBody
>

// ******************************************************************
// Amend
// ******************************************************************/

// TODO - assessor fields need added
export const NewEvdcDeviceAmendmentResponse = t.type({
    SystemReference: t.string,
    ManufacturerID: t.string,
    Make: t.string,
    Model: t.string,
    ModelReference: t.string,
    Module: t.string,
    EVCPType: t.string,
    Phases: t.number,
    Voltage: t.number,
    TotalEVCPInputRatedCurrent: t.number,
    TotalEVCPInputRatedPower: t.number,
    TotalEVCPMaxDemandCurrent: t.number,
    TotalEVCPMaxDemandPower: t.number,
    ModuleInputRatedCurrent: t.number,
    ModuleInputRatedPower: t.number,
    AppTestStandards_HarmonicStandards: t.string,
    Comments_AppTestStandards_Notes: t.union([t.string, t.null]),
    Attachment_UUID: t.string,
})

export const AmendEvdcDevicePostBody = t.type({
    device_type: t.literal("EVDC"),
    device_data: t.intersection([
        t.type({
            Model: t.string,
            Make: t.string,
            ModelReference: t.string,
            EVCPType: t.string,
            Module: t.string,
            Phases: t.number,
            Voltage: t.number,
            TotalEVCPInputRatedCurrent: t.number,
            TotalEVCPInputRatedPower: t.number,
            TotalEVCPMaxDemandCurrent: t.number,
            TotalEVCPMaxDemandPower: t.number,
            ModuleInputRatedCurrent: t.number,
            ModuleInputRatedPower: t.number,
            AppTestStandards_HarmonicStandards: t.string,
            Comments_AppTestStandards_Notes: t.string,
            Attachment_UUID: t.string,
        }),
        t.partial({
            ManufacturerID: t.string,
            SystemReference: t.string,
        }),
    ]),
})

export type TAmendEvdcDevicePostBody = t.TypeOf<typeof AmendEvdcDevicePostBody>

export type TNewEvdcDeviceAmendmentResponse = t.TypeOf<
    typeof NewEvdcDeviceAmendmentResponse
>

// ******************************************************************
// Version
// ******************************************************************/

// TODO - assessor fields need added
export const NewEvdcDeviceVersionResponse = t.type({
    SystemReference: t.string,
    ManufacturerID: t.string,
    Make: t.string,
    Model: t.string,
    ModelReference: t.string,
    Module: t.string,
    EVCPType: t.string,
    Phases: t.number,
    Voltage: t.number,
    TotalEVCPInputRatedCurrent: t.number,
    TotalEVCPInputRatedPower: t.number,
    TotalEVCPMaxDemandCurrent: t.number,
    TotalEVCPMaxDemandPower: t.number,
    ModuleInputRatedCurrent: t.number,
    ModuleInputRatedPower: t.number,
    AppTestStandards_HarmonicStandards: t.string,
    Comments_AppTestStandards_Notes: t.union([t.string, t.null]),
    Attachment_UUID: t.string,
})

export type TNewEvdcDeviceVersionResponse = t.TypeOf<
    typeof NewEvdcDeviceVersionResponse
>

// ******************************************************************
// Drafts
// ******************************************************************/
// TODO - assessor fields need added
export const ContinueEVDCDraftResponse = t.type({
    SystemReference: t.union([t.string, t.null]),
    ManufacturerID: t.union([t.string, t.null]),
    Make: t.union([t.string, t.null]),
    Model: t.union([t.string, t.null]),
    ModelReference: t.union([t.string, t.null]),
    Module: t.union([t.string, t.null]),
    EVCPType: t.union([t.string, t.null]),
    Phases: t.union([t.number, t.null]),
    Voltage: t.union([t.number, t.null]),
    TotalEVCPInputRatedCurrent: t.union([t.number, t.null]),
    TotalEVCPInputRatedPower: t.union([t.number, t.null]),
    TotalEVCPMaxDemandCurrent: t.union([t.number, t.null]),
    TotalEVCPMaxDemandPower: t.union([t.number, t.null]),
    ModuleInputRatedCurrent: t.union([t.number, t.null]),
    ModuleInputRatedPower: t.union([t.number, t.null]),
    AppTestStandards_HarmonicStandards: t.union([t.string, t.null]),
    Comments_AppTestStandards_Notes: t.union([t.string, t.null]),
    Attachment_UUID: t.union([t.string, t.null]),
})

// TODO - assessor fields
export const SaveEVDCDeviceDraftPostBody = t.type({
    device_type: t.literal("EVDC"),
    device_data: t.partial({
        SystemReference: t.string,
        ManufacturerID: t.string,
        Make: t.string,
        Model: t.string,
        ModelReference: t.string,
        Module: t.string,
        EVCPType: t.string,
        Phases: t.number,
        Voltage: t.number,
        TotalEVCPInputRatedCurrent: t.number,
        TotalEVCPInputRatedPower: t.number,
        TotalEVCPMaxDemandCurrent: t.number,
        TotalEVCPMaxDemandPower: t.number,
        ModuleInputRatedCurrent: t.number,
        ModuleInputRatedPower: t.number,
        AppTestStandards_HarmonicStandards: t.string,
        Comments_AppTestStandards_Notes: t.string,
        Attachment_UUID: t.string,
    }),
    is_amendment: t.boolean,
})

export type TSaveEVDCDeviceDraftPostBody = t.TypeOf<
    typeof SaveEVDCDeviceDraftPostBody
>

export type TContinueEVDCDraftResponse = t.TypeOf<
    typeof ContinueEVDCDraftResponse
>
// ******************************************************************
// Other
// ******************************************************************/

export type TEvdcDeviceResponseType =
    | TNewEvdcDeviceAmendmentResponse
    | TContinueEVDCDraftResponse
